module.exports = __webpack_public_path__ + "static/img/sanya.49f67d5.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/city/sanya.jpg
// module id = EM7r
// module chunks = 1